<template>
  <div class="artifact-task-card" :aria-label="`${label}任务`">
    <div class="artifact-task-title">{{ label }} · {{ statusLabel }} · 第 {{ job.revision }} 版</div>
    <div class="artifact-task-actions">
      <el-button v-if="job.status === 'waiting_outline_approval' || job.status === 'waiting_final_approval'"
        size="mini" type="primary" @click="$emit('review', job)">查看并确认</el-button>
      <el-button v-if="job.status === 'completed' && job.operationKind === 'analyze'"
        size="mini" @click="$emit('analysis', job)">查看分析</el-button>
      <el-button v-if="job.status === 'completed' && job.operationKind === 'create'"
        size="mini" @click="$emit('files', job)">下载成品</el-button>
      <span v-if="job.status === 'failed'" class="artifact-task-error">{{ job.safeErrorCode || '任务失败，请重试' }}</span>
    </div>
  </div>
</template>

<script>
const statusText = { waiting_outline_approval: '等待确认内容', queued: '排队中', running: '制作中',
  waiting_final_approval: '等待最终确认', finalizing: '发布中', completed: '已完成',
  failed: '失败', cancelled: '已取消' }

export default {
  name: 'agent-artifact-task-card',
  props: { job: { type: Object, required: true } },
  computed: {
    label() {
      return this.job.skillCode === 'document.word.create' ? 'Word'
        : this.job.skillCode === 'document.ppt.create' ? 'PPT'
          : this.job.operationKind === 'analyze' ? 'Excel 分析' : 'Excel 制作'
    },
    statusLabel() { return statusText[this.job.status] || this.job.status }
  }
}
</script>

<style scoped>
.artifact-task-card { max-width: 640px; margin: 8px 0; padding: 10px 12px;
  border: 1px solid #e4e7ed; border-radius: 8px; background: #fff; }
.artifact-task-title { font-size: 13px; font-weight: 600; }
.artifact-task-actions { margin-top: 8px; }
.artifact-task-error { color: #d33; font-size: 12px; }
</style>
